import hasRole from "./permission/hasRole";
import hasPermi from "./permission/hasPermi";
import copyText from "./common/copyText";
import dropUpload from "./common/dropUpload.js";

export default function directive(app) {
  app.directive("hasRole", hasRole);
  app.directive("hasPermi", hasPermi);
  app.directive("copyText", copyText);
  app.directive("dropUpload", dropUpload);
}
